import { changeCustomerBillToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(changeCustomerBillToSelectorStyles, {
    billToSelectorDynamicDropdown: {
        cssOverrides: {
            formInputWrapper: css`
                ul {
                    z-index: 1270;
                }
                @media (max-width: 1199px) and (min-width: 280px) {
                    ul {
                        max-height: 250px;
                    }
                }
                span[data-test-selector^="changeCustomerBillToSelector-selectedText"] {
                    width: 94%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    width: 90%;
                                `,
                                css`
                                    width: 95%;
                                `,
                                css`
                                    width: 92%;
                                `,
                            ],
                            "min",
                        )}
                }
            `,
        },
    },
});
